import { defineStore } from 'pinia';
import { ref } from 'vue';
import { api, ApiCallError } from '@/api/client';
import type { MeResponse } from '@/api/types';

export const useUserStore = defineStore('user', () => {
  const me = ref<MeResponse | null>(null);
  const loading = ref(false);
  const error = ref<string | null>(null);

  async function load() {
    loading.value = true;
    error.value = null;
    try {
      me.value = await api.get<MeResponse>('/me');
    } catch (e) {
      error.value = e instanceof ApiCallError ? e.message : 'Не удалось загрузить профиль';
    } finally {
      loading.value = false;
    }
  }

  return { me, loading, error, load };
});
